import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  const contactInfo = [
    {
      icon: '📞',
      label: '电话',
      value: '18902462700',
      link: 'tel:18902462700',
    },
    {
      icon: '💬',
      label: '微信',
      value: '18902462700',
      link: 'weixin://',
    },
    {
      icon: '📧',
      label: '邮箱',
      value: 'xlylc@mentaldeveloping.com',
      link: 'mailto:xlylc@mentaldeveloping.com',
    },
    {
      icon: '📍',
      label: '地址',
      value: '广东省深圳市龙华区高尔夫大道8号观澜湖新城3栋404',
      link: 'https://uri.amap.com/marker?position=114.056503,22.683421&name=深圳市高帝思教育咨询有限公司&src=mentaldeveloping&coordinate=gaode&callnative=1',
    },
  ];

  const qrCodes = [
    { type: 'official', label: '公众号', image: '/images/公众号.png' },
    { type: 'video', label: '视频号', image: '/images/视频号.png' },
    { type: 'xiaohongshu', label: '小程序', image: '/images/小程序店铺.png' },
    { type: 'miniprogram', label: '小红书', image: '/images/小红书.png' },
    { type: 'weixin', label: '微信小店', image: '/images/微信小店.png' },
  ];

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="section-header">
          <h2 className="section-title">联系我们</h2>
          <p className="section-subtitle">
            深圳市高帝思教育咨询有限公司
          </p>
        </div>

        <div className="contact-content">
          <div className="unified-contact-section">
            <div className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <div key={index} className="contact-info-item">
                  <div className="info-icon">{info.icon}</div>
                  <div className="info-details">
                    <div className="info-label">{info.label}</div>
                    {info.link ? (
                      <a href={info.link} className="info-value-link">
                        {info.value}
                      </a>
                    ) : (
                      <div className="info-value">{info.value}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="qr-codes-section">
              <h3 className="qr-section-title">关注我们</h3>
              <div className="qr-codes-grid">
                {qrCodes.map((qr, index) => (
                  <div key={index} className="qr-code-item">
                    <div className="qr-code-placeholder">
                      <span className="qr-icon">{qr.image ? <img src={qr.image} alt={qr.label} /> : '📱'}</span>
                    </div>
                    <span className="qr-label">{qr.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
